import axios from "axios";
import {createURL} from "./client";
import {syncPlayerProfileIfNeeded} from "../utils/playerProfileSync";
import {generateIdempotencyKey} from "../utils/idempotency";

// getPlayerInfo получает информацию о пользователе
export async function getPlayerInfo() {
    return axios.get(createURL("/api/player/")).then(resp => {
        const player = resp?.data?.response;
        syncPlayerProfileIfNeeded(player);
        return resp;
    });
}

// getTopWinners получает топ-3 игроков по количеству выигранных игр
export async function getTopWinners() {
    return await axios.get(createURL("/api/player/top-winners"));
}

// getPlayerRating получает рейтинг игроков по количеству выигранных игр
export async function getPlayerRating() {
    return await axios.get(createURL("/api/player/rating"));
}

// getWeeklyPlayerRating получает рейтинг игроков по количеству выигранных игр за неделю
export async function getWeeklyPlayerRating() {
    return await axios.get(createURL("/api/player/weekly-rating"));
}

// add3DailyAttempts начисляет игроку 3 бонусных жизни за монеты
export async function add3DailyAttempts(options = {}) {
    const idempotencyKey = options.idempotencyKey || generateIdempotencyKey();
    return await axios.post(
        createURL("/api/player/add-3-daily-attempts"),
        null,
        {headers: {"Idempotency-Key": idempotencyKey}},
    );
}

// getDailyAttemptsPrice получает текущую цену покупки жизней
export async function getDailyAttemptsPrice() {
    return await axios.get(createURL("/api/player/daily-attempts-price"));
}

// getFriendsRating получает рейтинг друзей
export async function getFriendsRating(friendIDs) {
    return await axios.post(createURL("/api/player/friends-rating"), { friend_ids: friendIDs });
}

// getWeeklyFriendsRating получает недельный рейтинг друзей
export async function getWeeklyFriendsRating(friendIDs) {
    return await axios.post(createURL("/api/player/weekly-friends-rating"), { friend_ids: friendIDs });
}

// syncPlayerProfile отправляет обновлённые данные профиля в бэкенд
export function syncPlayerProfile() {
    return axios.post(createURL("/api/player/sync-profile"));
}
